import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import axios from "axios";
import { request } from "@/js/http/http_request";
import { hasRole, isAdminNotConsultant } from "@/js/http/auth.js";
import { getErrorData, handleErrorData, ERROR_DATA, filterVAutocomplete } from "@/js/forms.js";
import { formRules } from "@/js/form_rules.js";
import { wineNaming } from "@/js/wine/wine.js";
import confirmationComponent from "@/components/modal/ConfirmationDialog.vue";
import ErrorModal from "@/components/modal/ErrorModal.vue";
export default {
  name: "Denomination",
  components: {
    confirm: confirmationComponent,
    ErrorModal: ErrorModal
  },
  props: {
    loggedUserData: Object,
    baseModel: Object,
    mode: String,
    isEdit: Boolean
  },
  data: function data() {
    return {
      isLoadingRegions: true,
      regions: [],
      isLoadingAppellationsParent: true,
      appellationsParents: [],
      isLoadingDenominations: true,
      existingAppellationDenominations: [],
      isShowExisitingAppellationDenominations: false,
      manageExistingDenomination: {
        form: {
          valid: false
        },
        model: {
          id_appellation: null,
          id_parent_appellation: null,
          appellation: ""
        },
        error: {
          delete: null
        }
      },
      saveDenominationCancellationToken: null,
      saveExistingDenominationCancellationToken: null,
      deleteExistingDenominationCancellationToken: null,
      managedExceptions: {
        error: {
          wine_attached: "At least one wine is attached this denomination. It can't be deleted."
        },
        warning: {
          appellation_exists: "A denomination with same configuration already exists."
        }
      },
      form: {
        valid: false
      },
      formRules: formRules,
      filterVAutocomplete: filterVAutocomplete,
      ERROR_DATA: ERROR_DATA
    };
  },
  computed: {
    canManageAppellations: function canManageAppellations() {
      return hasRole(process.env.VUE_APP_ROLES_MANAGE_APPELLATION);
    },
    isAuthorized: function isAuthorized() {
      return isAdminNotConsultant(this.loggedUserData) && this.canManageAppellations;
    }
  },
  created: function created() {
    var _this2 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (_this2.isAuthorized) {
              _context.next = 3;
              break;
            }
            _this2.cancel();
            return _context.abrupt("return");
          case 3:
            _this2.getRegions();
            _this2.getRegionAppellations();
            _this2.getAppellationDenominations();
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    getRegions: function getRegions() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this3.isLoadingRegions = true;
              _this = _this3;
              _context2.next = 4;
              return request("/v1/regions", "get", null, true, "api").catch(function (e) {
                _this.isLoadingRegions = false;
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to load regions list");
                handleErrorData(_this, errorData);
                throw e;
              });
            case 4:
              response = _context2.sent;
              _this3.isLoadingRegions = false;
              if (response.data !== null) _this3.regions = _toConsumableArray(response.data);
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    getRegionAppellations: function getRegionAppellations() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!_this4.baseModel.region.id) {
                _context3.next = 10;
                break;
              }
              _this4.isLoadingAppellationsParents = true;
              _this = _this4;
              _context3.next = 5;
              return request("/v1/regions/".concat(_this4.baseModel.region.id, "/appellations"), "get", null, true, "api").catch(function (e) {
                _this.isLoadingAppellationsParents = false;
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to load existing appellations");
                handleErrorData(_this, errorData);
                throw e;
              });
            case 5:
              response = _context3.sent;
              if (response.data !== null) _this4.appellationsParents = _toConsumableArray(response.data);
              _this4.isLoadingAppellationsParents = false;
              _context3.next = 11;
              break;
            case 10:
              _this4.appellationsParents = [];
            case 11:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    getAppellationDenominations: function getAppellationDenominations() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _this5.isShowExisitingAppellationDenominations = false;
              if (!_this5.baseModel.id_parent_appellation) {
                _context4.next = 11;
                break;
              }
              _this5.isLoadingAppellationDenominations = true;
              _this = _this5;
              _context4.next = 6;
              return request("/v1/appellations/".concat(_this5.baseModel.id_parent_appellation, "/denominations"), "get", null, true, "api").catch(function (e) {
                _this.isLoadingAppellationDenominations = false;
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to load existing denominations");
                handleErrorData(_this, errorData);
                throw e;
              });
            case 6:
              response = _context4.sent;
              _this5.isLoadingAppellationDenominations = false;
              if (response.data !== null) _this5.existingAppellationDenominations = _toConsumableArray(response.data);
              _context4.next = 12;
              break;
            case 11:
              _this5.existingAppellationDenominations = [];
            case 12:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    toggleShowDenominations: function toggleShowDenominations() {
      this.isShowExisitingAppellationDenominations = !this.isShowExisitingAppellationDenominations;
    },
    save: function save() {
      if (!this.isEdit) {
        this.saveDenomination("post");
      } else {
        this.saveDenomination("put");
      }
    },
    saveDenomination: function saveDenomination(verb) {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var _this, data, response;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _this6.$EventBus.$emit("loading", true);
              _this = _this6;
              data = {
                id: _this.baseModel.id_appellation,
                name: _this.baseModel.appellation,
                regionId: _this.baseModel.region.id,
                parentAppellationId: _this.baseModel.id_parent_appellation
              };
              _context5.prev = 3;
              _context5.next = 6;
              return request("/v1/appellations/denominations", verb, data, true, "api").catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to save denomination");
                _this.$toasted.show(errorData.message, {
                  type: errorData.type
                });
                throw e;
              });
            case 6:
              response = _context5.sent;
              if (response.status == 201 || response.status == 200) {
                _this6.$toasted.show("Denomination saved.", {
                  type: "success"
                });
                _this6.$EventBus.$emit("loading", false);
                _this6.$emit("saved", response.data ? response.data : _this.baseModel.id_appellation);
              }
              _context5.next = 12;
              break;
            case 10:
              _context5.prev = 10;
              _context5.t0 = _context5["catch"](3);
            case 12:
              _this6.$EventBus.$emit("loading", false);
            case 13:
            case "end":
              return _context5.stop();
          }
        }, _callee5, null, [[3, 10]]);
      }))();
    },
    saveEditExistingDenomination: function saveEditExistingDenomination() {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var _this7$saveExistingDe;
        var _this, data, response;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _this7.$EventBus.$emit("loading", true);
              (_this7$saveExistingDe = _this7.saveExistingDenominationCancellationToken) === null || _this7$saveExistingDe === void 0 || _this7$saveExistingDe.cancel();
              _this7.saveExistingAppellationCancellationToken = axios.CancelToken.source();
              _this = _this7;
              data = {
                id: _this.manageExistingDenomination.model.id_appellation,
                name: _this.manageExistingDenomination.model.appellation,
                regionId: _this.baseModel.region.id,
                parentAppellationId: _this.baseModel.id_parent_appellation
              };
              _context6.prev = 5;
              _context6.next = 8;
              return request("/v1/appellations/denominations", "put", data, true, "api", null, _this.saveExistingDenominationCancellationToken).catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to save denomination");
                handleErrorData(_this, errorData);
                throw e;
              });
            case 8:
              response = _context6.sent;
              if (!(response.status == 201 || response.status == 200)) {
                _context6.next = 14;
                break;
              }
              _this.$toasted.show("Denomination saved.", {
                type: "success"
              });
              _context6.next = 13;
              return _this.getAppellationDenominations();
            case 13:
              _this7.closeEditExistingDenomination();
            case 14:
              _context6.next = 18;
              break;
            case 16:
              _context6.prev = 16;
              _context6.t0 = _context6["catch"](5);
            case 18:
              _this7.$EventBus.$emit("loading", false);
            case 19:
            case "end":
              return _context6.stop();
          }
        }, _callee6, null, [[5, 16]]);
      }))();
    },
    cancel: function cancel() {
      this.$emit("cancel");
    },
    deleteDenomination: function deleteDenomination(id_appellation) {
      var _this8 = this;
      this.$refs.confirm.open("Delete", "Are you sure you want to delete this denomination ?", {
        color: "red"
      }).then(/*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8(confirm) {
          var _this8$deleteExisting, _this;
          return _regeneratorRuntime().wrap(function _callee8$(_context8) {
            while (1) switch (_context8.prev = _context8.next) {
              case 0:
                if (!confirm) {
                  _context8.next = 17;
                  break;
                }
                _this8.closeEditExistingDenomination();
                _context8.prev = 2;
                _this8.$EventBus.$emit("loading", true);
                (_this8$deleteExisting = _this8.deleteExistingDenominationCancellationToken) === null || _this8$deleteExisting === void 0 || _this8$deleteExisting.cancel();
                _this8.deleteExistingAppellationCancellationToken = axios.CancelToken.source();
                _this = _this8;
                _context8.next = 9;
                return request("/v1/appellations/denominations/".concat(id_appellation), "delete", null, true, "api", null, _this8.deleteExistingDenominationCancellationToken).catch(/*#__PURE__*/function () {
                  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7(e) {
                    var errorData;
                    return _regeneratorRuntime().wrap(function _callee7$(_context7) {
                      while (1) switch (_context7.prev = _context7.next) {
                        case 0:
                          errorData = getErrorData(e, _this.managedExceptions, "Unable to delete denomination");
                          handleErrorData(_this, errorData);
                          if ((errorData === null || errorData === void 0 ? void 0 : errorData.code) === "wine_attached") {
                            _this.getErrorWinesAttached(id_appellation);
                          }
                          throw e;
                        case 4:
                        case "end":
                          return _context7.stop();
                      }
                    }, _callee7);
                  }));
                  return function (_x2) {
                    return _ref2.apply(this, arguments);
                  };
                }());
              case 9:
                _this8.getAppellationDenominations();
                _this8.closeEditExistingDenomination();
                _this8.$toasted.show("Denomination deleted", {
                  type: "success"
                });
                _context8.next = 16;
                break;
              case 14:
                _context8.prev = 14;
                _context8.t0 = _context8["catch"](2);
              case 16:
                _this8.$EventBus.$emit("loading", false);
              case 17:
              case "end":
                return _context8.stop();
            }
          }, _callee8, null, [[2, 14]]);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    getErrorWinesAttached: function getErrorWinesAttached(id_appellation) {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        var response;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return request("/v1/appellations/denominations/".concat(id_appellation, "/wines"), "get", null, true, "api");
            case 2:
              response = _context9.sent;
              if (response.data !== null) {
                _this9.manageExistingDenomination.error.delete = {
                  id_appellation: id_appellation,
                  code: "wine_attached",
                  data: _toConsumableArray(response.data),
                  isDetailsShown: false
                };
              }
            case 4:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      }))();
    },
    toggleShowErrorDeleteWinesAttached: function toggleShowErrorDeleteWinesAttached() {
      this.manageExistingDenomination.error.delete.isDetailsShown = !this.manageExistingDenomination.error.delete.isDetailsShown;
    },
    startEditDenomination: function startEditDenomination(id_appellation) {
      this.manageExistingDenomination.model = _objectSpread({}, this.existingAppellationDenominations.find(function (x) {
        return x.id_appellation === id_appellation;
      }));
      this.resetErrorsManagingExisting();
    },
    closeEditExistingDenomination: function closeEditExistingDenomination() {
      this.manageExistingDenomination.model = {
        id_appellation: null,
        appellation: "",
        id_classification: null
      };
      this.resetErrorsManagingExisting();
    },
    resetErrorsManagingExisting: function resetErrorsManagingExisting() {
      this.manageExistingDenomination.error = {
        delete: null
      };
    },
    formatWineNaming: function formatWineNaming(wineNamingData) {
      return wineNaming(this.$whitelabel, wineNamingData, true, true, false);
    }
  }
};